import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import {
    PlaceData,
} from '../../@types/_place';

// ----------------------------------------------------------------------

type PlaceState = {
    isLoading: boolean;
    error: boolean;
    places: PlaceData[];
    currentPlace: PlaceData | null;
};

const initialState: PlaceState = {
    isLoading: false,
    error: false,
    places: [],
    currentPlace: null,
};

const slice = createSlice({
    name: 'place',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET PLACES
        getPlacesSuccess(state, action) {
            state.isLoading = false;
            state.places = action.payload;
            const currentPlaceId = localStorage.getItem('currentPlaceId')
            const found = action.payload.find((element: { id: string | null; }) => element.id == currentPlaceId);
            if(found != null){
                state.currentPlace = found;
            }else{
                state.currentPlace = action.payload[0];
            }
        },

        // SET CURRENT PLACE
        setCurrentPlace(state, action) {
            state.currentPlace = action.payload;
            localStorage.setItem('currentPlaceId', action.payload.id);
        },
        
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { setCurrentPlace } = slice.actions;

// ----------------------------------------------------------------------

export function getPlaces(u_id: string) {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const searchParams = new URLSearchParams({ u_id });
            const response = await axios.get('/place/query/userId?' + searchParams.toString());
            dispatch(slice.actions.getPlacesSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
